import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtilsService } from './http-utils.service';
import { Observable, catchError, map, mergeMap } from 'rxjs';
import { JsonConvert } from 'json2typescript';
import { Paging } from '../../model/paging/paging';
import { environment } from '../../../environment/environment';
import { GodCreate, GodCreateDataAll, GodCreateListData } from '../../model/god/god_create';


@Injectable({
    providedIn: 'root'
})
export class GodUserService {
    private _url: string = `${environment.baseAPI}/god/accounts`; // Endpoint ipotizzato

    constructor(private _http: HttpClient, private _httpUtils: HttpUtilsService) { }

    GETGodUsers(paging: Paging): Observable<GodCreateListData | any> {
        try {
            return this._httpUtils.getHTTPHeadersAsyncTenant().pipe(
                mergeMap(httpHeaders => {
                    return this._http.get(`${this._url}${paging.getQs()}`, { headers: httpHeaders }).pipe(
                        map((res: any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: GodCreateListData = jsonConvert.deserializeObject(res, GodCreateListData);
                            if (response.success) {
                                return response;
                            } else {
                                this._httpUtils.handleError(response);
                                return;
                            }
                        }, catchError(err => {
                            if (err.status === 401) { this._httpUtils.logout(); }
                            throw err;
                        })));
                }), catchError(err => { throw err; })
            );
        } catch (error) {
            throw error;
        }
    }

    GETGodUsersAll(): Observable<GodCreateDataAll | any> {
        try {
            return this._httpUtils.getHTTPHeadersAsyncTenant().pipe(
                mergeMap(httpHeaders => {
                    return this._http.get(`${this._url}/all`, { headers: httpHeaders }).pipe(
                        map((res: any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: GodCreateDataAll = jsonConvert.deserializeObject(res, GodCreateDataAll);
                            if (response.success) {
                                return response;
                            } else {
                                this._httpUtils.handleError(response);
                                return;
                            }
                        }, catchError(err => {
                            if (err.status === 401) { this._httpUtils.logout(); }
                            throw err;
                        })));
                }), catchError(err => { throw err; })
            );
        } catch (error) {
            throw error;
        }
    }

    PUTGodUser(id: string, data: Partial<GodCreate>): Observable<any> {
        try {
            return this._httpUtils.getHTTPHeadersAsyncTenant().pipe(
                mergeMap(httpHeaders => {
                    return this._http.put(`${this._url}/${id}`, data, { headers: httpHeaders }).pipe(
                        map((res: any) => res),
                        catchError(err => {
                            if (err.status === 401) { this._httpUtils.logout(); }
                            throw err;
                        })
                    );
                }), catchError(err => { throw err; })
            );
        } catch (error) {
            throw error;
        }
    }

    POSTGodUser(data: Partial<GodCreate>): Observable<any> {
        try {
            return this._httpUtils.getHTTPHeadersAsyncTenant().pipe(
                mergeMap(httpHeaders => {
                    return this._http.post(`${this._url}`, data, { headers: httpHeaders }).pipe(
                        map((res: any) => res),
                        catchError(err => {
                            if (err.status === 401) { this._httpUtils.logout(); }
                            throw err;
                        })
                    );
                }), catchError(err => { throw err; })
            );
        } catch (error) {
            throw error;
        }
    }

    DELETEGodUser(id: string): Observable<any> {
        try {
            return this._httpUtils.getHTTPHeadersAsyncTenant().pipe(
                mergeMap(httpHeaders => {
                    return this._http.delete(`${this._url}/${id}`, { headers: httpHeaders }).pipe(
                        map((res: any) => res),
                        catchError(err => {
                            if (err.status === 401) { this._httpUtils.logout(); }
                            throw err;
                        })
                    );
                }), catchError(err => { throw err; })
            );
        } catch (error) {
            throw error;
        }
    }
}